import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { AccessLog } from '../models/access-log.model';

@Injectable({
    providedIn: 'root'
})
export class AccessLogService {

    constructor(private readonly http: HttpClient) { }

    getAccessLog$(page: number): Observable<AccessLog[]> {
        return this.http.get<AccessLog[]>(`${environment.backendUrl}/accesslog/getaccesslog`, { params: { page } })
    }
}
